module.exports = __webpack_public_path__ + "static/media/materialAwesome.b79d36a3.ttf";